// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2arl2","containerItemsCenter":"Skeleton_containerItemsCenter__17zSx"};